// Условия списка замещений в адресе страницы (T064; contracts/api.md, GET /api/substitutions):
// поиск по ФИО владельца роли или заместителя, состояние, сортировка по сроку. Без состояния —
// все замещения; без сортировки — порядок по состоянию (defaultSubstitutionSort).
import { substitutionSortFields, substitutionStates } from '@kp/contracts';
import type { SubstitutionSort, SubstitutionState } from '@kp/contracts';

export type SubstitutionSortField = (typeof substitutionSortFields)[number];

export interface SubstitutionsSearch {
  q?: string;
  state?: SubstitutionState;
  sort?: SubstitutionSort;
}

const sortValues = substitutionSortFields.flatMap((field) => [
  field,
  `-${field}`,
]) as SubstitutionSort[];

export function parseSubstitutionsSearch(search: Record<string, unknown>): SubstitutionsSearch {
  const result: SubstitutionsSearch = {};
  if (typeof search.q === 'string' && search.q.trim() !== '') result.q = search.q;
  if (
    typeof search.state === 'string' &&
    (substitutionStates as readonly string[]).includes(search.state)
  ) {
    result.state = search.state as SubstitutionState;
  }
  if (typeof search.sort === 'string' && (sortValues as readonly string[]).includes(search.sort)) {
    result.sort = search.sort as SubstitutionSort;
  }
  return result;
}

/** Условия сужают список: «Ничего не найдено» вместо «Замещений нет». */
export function hasFilters(search: SubstitutionsSearch): boolean {
  return Boolean(search.q?.trim() || search.state);
}

/** Сортировка: «Сортировка: начало». */
export const substitutionSortLabels = {
  validFrom: 'Начало',
  validTo: 'Конец',
} as const satisfies Record<SubstitutionSortField, string>;

/** Фильтр «Состояние»: значения во множественном числе. */
export const substitutionStateFilterLabels = {
  active: 'Действующие',
  planned: 'Запланированные',
  ended: 'Закончившиеся',
  cancelled: 'Отменённые',
} as const satisfies Record<SubstitutionState, string>;
